import { Branch } from "./Branch.js";

export const branchPhoneMap: Record<Exclude<Branch, Branch.Central>, string> = {
	[Branch.Cakovice]: "+420 775 033 520",
	[Branch.Petriny]: "+420 775 033 564",
};
